import Layout from '@/views/notifications/Layout.vue';

export default {
    path: '/notifications',
    component: Layout,
    children: [
        { path: ':id', component: () => import('@/views/notifications/NotificationDetail.vue') },
    ]
};
